export function setTeamMember(teamMembers = [], teamMemberId, data = {}) {
  return teamMembers.map((teamMember) => {
    return teamMember.id === teamMemberId ? data : teamMember;
  });
}

export function removeTeamMember(teamMembers, teamMemberId) {
  return teamMembers.filter(({ id }) => id !== teamMemberId);
}
